import * as React from "react";
const SvgFiRrDirectionSignalArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-direction-signal-arrow_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 .668-.26 1.296-.732 1.768l-2.939 2.939a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L21.208 13h-5.207c-1.654 0-3 1.346-3 3v7a1 1 0 0 1-2 0v-3c0-1.654-1.346-3-3-3H2.793l2.293 2.293a.999.999 0 1 1-1.414 1.414L.733 17.768A2.48 2.48 0 0 1 .001 16c0-.668.26-1.296.732-1.768l2.939-2.939a.999.999 0 1 1 1.414 1.414L2.793 15H8c1.125 0 2.164.373 3 1.003V2.793L8.707 5.086a.999.999 0 1 1-1.414-1.414L10.232.733C10.636.328 11.5.001 12 .001s1.363.328 1.768.732l2.939 2.939a.999.999 0 1 1-1.414 1.414L13 2.793v9.21A4.97 4.97 0 0 1 16 11h5.207l-2.293-2.293a.999.999 0 1 1 1.414-1.414l2.939 2.939c.473.472.733 1.1.733 1.768"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-direction-signal-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDirectionSignalArrow;
